import React from "react";

const UserRegistration = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38.588"
      height="39.076"
      viewBox="0 0 38.588 39.076"
    >
      <g
        id="Group_6378"
        data-name="Group 6378"
        transform="translate(-618.104 -425.281)"
      >
        <path
          id="Subtraction_2"
          data-name="Subtraction 2"
          d="M18725.2-14985.562H18704a16.791,16.791,0,0,1,16.771-16.771h1.52a16.66,16.66,0,0,1,9.605,3.029,10.45,10.45,0,0,0-7.371,10.025,10.478,10.478,0,0,0,.676,3.716Zm-3.674-17.6a8.432,8.432,0,0,1-8.422-8.421,8.429,8.429,0,0,1,8.422-8.416,8.428,8.428,0,0,1,8.42,8.416A8.43,8.43,0,0,1,18721.529-15003.161Z"
          transform="translate(-18085.896 15445.279)"
          fill="#404040"
        />
        <path
          id="corref"
          d="M47.472,40a7.472,7.472,0,1,0,7.472,7.472A7.472,7.472,0,0,0,47.472,40Zm4.11,6.1L46.6,49.838a.623.623,0,0,1-.872-.125L43.86,47.223a.623.623,0,0,1,1-.748l1.494,1.993,4.483-3.362a.623.623,0,0,1,.748,1Z"
          transform="matrix(0.985, -0.174, 0.174, 0.985, 593.041, 417.193)"
          fill="#404040"
        />
      </g>
    </svg>
  );
};

export default UserRegistration;
